import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import HubspotForm from 'react-hubspot-form'
import { graphql } from 'gatsby'

export default function NewsletterForm() {
  const intl = useIntl()
  const portalId = process.env.GATSBY_HUBSPOT_PORTAL_ID || '25431082'
  const formId =
    intl.locale === 'en'
      ? process.env.GATSBY_HUBSPOT_NEWSLETTER_FORM_ID_EN
      : process.env.GATSBY_HUBSPOT_NEWSLETTER_FORM_ID_FR || '65f3eb8e-db1a-4405-a9ad-d73e42537d88'

  return (
    <HubspotForm
      portalId={portalId}
      formId={formId}
      region="eu1"
      onSubmit={() => console.log('Submit!')}
      onReady={form => console.log('Form ready!', form)}
      loading={
        <div className="p-5 d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status" />
        </div>
      }
    />
  )
}

export const query = graphql`
  fragment NewsletterFragment on ContentfulWidgetNewsletter {
    __typename
    id: contentful_id
    name
  }
`
